import * as TestActions from '../actions/testActions';

const defaultState = {
    test: {},
    updating: false
};



export default (state = defaultState, action) => {
    switch (action.type) {
        case TestActions.ACTION_TEST_RETRIEVED:
            return {
                ...state,
                test: action.payload,
                updating: false
            };
        case TestActions.ACTION_TEST_UPDATING:
            return {
                ...state,
                updating: true
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/testReducer.js